import React from 'react';
import { G, Path } from 'react-native-svg';

import { IconDef } from './types';

export const HourGlass: IconDef = {
  svg: (
    <G>
      <Path
        d="M9 19H15M6.6 2.5H17.4C17.9601 2.5 18.2401 2.5 18.454 2.60899C18.6422 2.70487 18.7951 2.85785 18.891 3.04601C19 3.25992 19 3.53995 19 4.1V6.17452C19 6.6637 19 6.90829 18.9447 7.13846C18.8957 7.34254 18.8149 7.53763 18.7053 7.71657C18.5816 7.9184 18.4086 8.09135 18.0627 8.43726L15.1314 11.3686C14.7354 11.7646 14.5373 11.9627 14.4632 12.191C14.3979 12.3918 14.3979 12.6082 14.4632 12.809C14.5373 13.0373 14.7354 13.2354 15.1314 13.6314L18.0627 16.5627C18.4086 16.9086 18.5816 17.0816 18.7053 17.2834C18.8149 17.4624 18.8957 17.6575 18.9447 17.8615C19 18.0917 19 18.3363 19 18.8255V20.9C19 21.4601 19 21.7401 18.891 21.954C18.7951 22.1422 18.6422 22.2951 18.454 22.391C18.2401 22.5 17.9601 22.5 17.4 22.5H6.6C6.03995 22.5 5.75992 22.5 5.54601 22.391C5.35785 22.2951 5.20487 22.1422 5.10899 21.954C5 21.7401 5 21.4601 5 20.9V18.8255C5 18.3363 5 18.0917 5.05526 17.8615C5.10425 17.6575 5.18506 17.4624 5.29472 17.2834C5.4184 17.0816 5.59135 16.9086 5.93726 16.5627L8.86863 13.6314C9.26465 13.2354 9.46265 13.0373 9.53684 12.809C9.6021 12.6082 9.6021 12.3918 9.53684 12.191C9.46266 11.9627 9.26464 11.7646 8.86863 11.3686L5.93726 8.43726C5.59136 8.09136 5.4184 7.9184 5.29472 7.71657C5.18506 7.53763 5.10425 7.34254 5.05526 7.13846C5 6.90829 5 6.6637 5 6.17452V4.1C5 3.53995 5 3.25992 5.10899 3.04601C5.20487 2.85785 5.35785 2.70487 5.54601 2.60899C5.75992 2.5 6.03995 2.5 6.6 2.5Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
  ),
  svgStyles(color) {
    return {
      stroke: color,
      strokeWidth: 2,
    };
  },
};
